import React from 'react';

const PermissionButton = ({ hasPermission, isAllowed, onClick }) => {

  const isActive = hasPermission && isAllowed;
  const isDisabled = !isAllowed;

  return (
    <div className="flex items-center justify-center">
      <button 
        className={`p-2 flex justify-center  items-center transition-colors rounded-[4px] w-[49px] h-[37px]
          ${isActive ? 'bg-[#43B02A] hover:bg-[#3c9c26] cursor-pointer' : 'bg-[#EFEEF7]   border-[#D9D9D9] border-[1px]'} 
          ${isDisabled ? ' bg-opacity-25 cursor-not-allowed ' : 'hover:bg-gray-300 '}
        `}
        onClick={onClick}
        disabled={isDisabled}
      >
        <svg className={` ${isDisabled ? 'opacity-25' : ''}`}  width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1681_59818)">
            <path d="M6.5 12.5L10.4953 16.5L18.5 8.5"
              stroke={isActive ? '#FFFFFF' : '#292D32'} 
              strokeWidth="1.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1681_59818">
              <rect width="24" height="24" fill="white" transform="translate(0.5 0.5)"/>
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>
  );
};

export default PermissionButton;